/* eslint-disable default-param-last */
export const types = {
  SET_SEGMENT: 'FORM_ADDITIONAL_FIBER/SET_SEGMENT',
  INIT_PURCHASE: 'FORM_ADDITIONAL_FIBER/INIT_PURCHASE',
  INIT_PURCHASE_SUCCESS: 'FORM_ADDITIONAL_FIBER/INIT_PURCHASE_SUCCESS',
  SET_INFO: 'FORM_ADDITIONAL_FIBER/SET_INFO',
  SET_INFO_SUCCESS: 'FORM_ADDITIONAL_FIBER/SET_INFO_SUCCESS',
  CHECKOUT_REQUEST: 'FORM_ADDITIONAL_FIBER/CHECKOUT_REQUEST',
  CHECKOUT_REQUEST_SUCCESS: 'FORM_ADDITIONAL_FIBER/CHECKOUT_REQUEST_SUCCESS',
  SEND_PURCHASE_OTP: 'FORM_ADDITIONAL_FIBER/SEND_PURCHASE_OTP',
  VALIDATE_PURCHASE_OTP: 'FORM_ADDITIONAL_FIBER/VALIDATE_PURCHASE_OTP',
  PROCESS_ORDER: 'FORM_ADDITIONAL_FIBER/PROCESS_ORDER',
  PROCESS_ORDER_SUCCESS: 'FORM_ADDITIONAL_FIBER/PROCESS_ORDER_SUCCESS',
};

export const actions = {
  setSegment: (data) => ({
    type: types.SET_SEGMENT,
    payload: { data },
  }),
  initPurchase: (data) => ({
    type: types.INIT_PURCHASE,
    payload: { data },
  }),
  initPurchaseSuccess: (data) => ({
    type: types.INIT_PURCHASE_SUCCESS,
    payload: { data },
  }),
  setInfo: (data) => ({
    type: types.SET_INFO,
    payload: { data },
  }),
  setInfoSuccess: (data) => ({
    type: types.SET_INFO_SUCCESS,
    payload: { data },
  }),
  checkout: (data) => ({
    type: types.CHECKOUT_REQUEST,
    payload: { data },
  }),
  checkoutSuccess: (data) => ({
    type: types.CHECKOUT_REQUEST_SUCCESS,
    payload: { data },
  }),
  sendSmsOtp: (data) => ({
    type: types.SEND_PURCHASE_OTP,
    payload: { data },
  }),
  validateSmsOtp: (data) => ({
    type: types.VALIDATE_PURCHASE_OTP,
    payload: { data },
  }),
  processOrder: (data) => ({
    type: types.PROCESS_ORDER,
    payload: { data },
  }),
  processOrderSuccess: (data) => ({
    type: types.PROCESS_ORDER_SUCCESS,
    payload: { data },
  }),
};

const initialState = {
  segment: null,
  loadingForm: false,
  loadingShoppingCart: false,
  loadingButtonShoppingCart: false,
  initialShoppingCart: null,
  shoppingCart: null,
  customerInfo: null,
  sendingSmsOtp: false,
  otpSent: false,
  validatingSmsOtp: false,
  otpValidated: false,
  processingOrder: false,
  pageTexts: null,
};

function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case types.SET_SEGMENT: {
      const { data } = { ...action.payload };
      const { segment } = { ...data };
      return {
        ...state,
        segment,
      };
    }
    case types.INIT_PURCHASE: {
      return {
        ...state,
        loadingForm: true,
      };
    }
    case types.INIT_PURCHASE_SUCCESS: {
      const { data } = { ...action.payload };
      const { shoppingCartInfoNormalized, customerInfoNormalized, pageTextsNormalized } = {
        ...data,
      };
      return {
        ...state,
        loadingForm: false,
        initialShoppingCart: shoppingCartInfoNormalized,
        shoppingCart: shoppingCartInfoNormalized,
        customerInfo: customerInfoNormalized,
        pageTexts: pageTextsNormalized,
      };
    }
    case types.SET_INFO: {
      const { data } = { ...action.payload };
      const { skipCheckCoverage } = { ...data };
      return {
        ...state,
        loadingShoppingCart: !skipCheckCoverage,
      };
    }
    case types.SET_INFO_SUCCESS: {
      const { data } = { ...action.payload };
      return {
        ...state,
        loadingShoppingCart: false,
        shoppingCart: data,
      };
    }
    case types.CHECKOUT_REQUEST: {
      const { data } = { ...action.payload };
      const { loadingButtonShoppingCart } = { ...data };
      return {
        ...state,
        ...(loadingButtonShoppingCart
          ? { loadingButtonShoppingCart: true }
          : {}),
      };
    }
    case types.CHECKOUT_REQUEST_SUCCESS: {
      return {
        ...state,
        loadingButtonShoppingCart: false,
      };
    }
    case types.PROCESS_ORDER: {
      return {
        ...state,
        processingOrder: true,
      };
    }
    case types.PROCESS_ORDER_SUCCESS: {
      return {
        ...state,
        processingOrder: false,
      };
    }
    default:
      return state;
  }
}

export default reducer;
